class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    var bundleProduct = false;

    if (typeof bundleTemplate !== "undefined" && bundleTemplate.isBundleTemplate) {
      if(bundleVariantOne) {
        bundleProduct = true;
      }
    }

    var bundleVariantIds = [...document.querySelectorAll('.bundle-item-components')];
    var bundleProductInCart = [];
    var len = bundleVariantIds.length;
    for (var i = 0; i < len; i++) {
      bundleProductInCart.push({
        bundleVarId: bundleVariantIds[i].attributes.bundleVarId.value,
        bundleVarTotalQuant: bundleVariantIds[i].attributes.bundleVarTotalQuant.value,
        bundleVariantTitle: bundleVariantIds[i].innerText,
      });
    }

    var result1 = [...bundleProductInCart.reduce( (mp, o) => {
      if (!mp.has(o.bundleVarId)) mp.set(o.bundleVarId, { ...o, count: 0 });
      mp.get(o.bundleVarId).count++;
      return mp;
    }, new Map).values()];

    cartGetBundleComponents();
    var errorsFound = 0;
    var bundleErrorMessage = '';
    var result = [...cartItemComponents.reduce( (mp, o) => {
      if (!mp.has(o.id)) mp.set(o.id, { ...o, count: 0 });
      mp.get(o.id).count++;
      return mp;
    }, new Map).values()];

    for(let i = 0; i < bundleProductInCart.length; i++) {

      if(result || result1) {
        var checkIfBundleVarInCart = result.find(e => e.id == bundleProductInCart[i].bundleVarId);
        var checkIfBundleVarInCart2 = result1.find(e => e.id == bundleProductInCart[i].bundleVarId);
        var checkIfBundleVarInCart3 = result1.find(e => e.bundleVarId == bundleProductInCart[i].bundleVarId);
    
        if((checkIfBundleVarInCart && checkIfBundleVarInCart.count == bundleProductInCart[i].bundleVarTotalQuant) || (checkIfBundleVarInCart2 && checkIfBundleVarInCart2.count == bundleProductInCart[i].bundleVarTotalQuant) || (checkIfBundleVarInCart3 && checkIfBundleVarInCart3.count == bundleProductInCart[i].bundleVarTotalQuant)) {
          errorsFound = errorsFound + 1;
          var bundleErrVariant = document.querySelectorAll(`[bundlevarid="${bundleProductInCart[i].bundleVarId}"]`);
          bundleErrVariant.forEach((element) => {
            var quantityParentElement = element.parentElement.parentElement.querySelector('.cart-quantity');
            quantityParentElement.querySelector('.quantity__input').setAttribute('disabled', 'disabled');
            quantityParentElement.querySelector('.cart-quantity [name="plus"]').setAttribute('disabled', 'disabled');
            quantityParentElement.querySelector('.cart-quantity [name="plus"]').style.color = 'gray';
            quantityParentElement.querySelector('.cart-quantity [name="plus"]').style.cursor = 'not-allowed';
          })
        } else if((checkIfBundleVarInCart && checkIfBundleVarInCart.count < bundleProductInCart[i].bundleVarTotalQuant) || (checkIfBundleVarInCart2 && checkIfBundleVarInCart2.count < bundleProductInCart[i].bundleVarTotalQuant) || (checkIfBundleVarInCart3 && checkIfBundleVarInCart3.count < bundleProductInCart[i].bundleVarTotalQuant)) {
          errorsFound = errorsFound + 0;
        } else {
          errorsFound = errorsFound + 0;
        }
      }
    }

    
    if(bundleProduct) {
      window.Klarna.OnsiteMessaging.refresh();      
    }

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    const scrollbarVisible = (element) => {
      return element.scrollHeight > element.clientHeight;
    }
    const cartDrawerContainer = document.querySelector('cart-drawer-items')
        
    if(scrollbarVisible(cartDrawerContainer) === true) {
      document.querySelector('.cart-drawer .drawer__cart-items-wrapper').style.marginRight = '1rem';
      document.querySelector('.cart-drawer .cart-alert').style.marginRight = '1rem';
      document.querySelector('.cart-drawer .slider-button--next').style.marginRight = '1rem';
    }

    let cartItems = document.querySelectorAll('#CartDrawer .cart-items tr');
    cartItems.forEach(function(item) {
      if (item.getAttribute('data-product-id') === '7250028822704') {
        removeShippingProtection();
      }
    });

    // const shippingProtectionOptedOut = sessionStorage.getItem('le_ship_protection_opted_out');

    // if(!shippingProtectionOptedOut || shippingProtectionOptedOut == 'false') {
    //   document.getElementById('cartShippingProtection').checked = true;
    //   determineShippingProtection();
    // } else if (shippingProtectionOptedOut == 'true') {
    //   document.getElementById('cartShippingProtection').checked = false;
    //   determineShippingProtection();
    // }

    // document.getElementById('cartShippingProtection').addEventListener('change', function(e) {
    //   determineShippingProtection();
    // });

    if(document.getElementById('gwp__user-add-submit-button')) {
      document.getElementById('gwp__user-add-submit-button').addEventListener('click', addUserAddGiftWithPurchase);
      gwpSelectChange();
    }

    if(document.getElementById('pouch__user-add-submit-button')) {
      document.getElementById('pouch__user-add-submit-button').addEventListener('click', addPouchAddon);
      checkIfPouchExistsInCart();
    }

    /* Progress Bar - Cart Drawer */
    const goalValue = document.querySelector('.cart-alert').getAttribute("metafield-goal-value");
    let cartSubtotalValue = document.querySelector(".cart-drawer__footer .totals__subtotal-value").getAttribute('value');
    let goalRemainingValue = goalValue - cartSubtotalValue;
    goalRemainingValue = Number(goalRemainingValue).toFixed(2);
  
    if(goalRemainingValue > 0) {
      document.querySelector('.cart-alert__remaining-message').classList.remove('hidden');
      document.querySelector('.cart-alert__qualify-message').classList.add('hidden');
      document.querySelector('.cart-alert__goal-calc').innerHTML = `$${goalRemainingValue}`;
      document.querySelector('.cart-alert__progress-bar').setAttribute('value', goalValue - goalRemainingValue);
      document.querySelector('.cart-drawer__estimated-shipping').innerHTML = '$8'
    } else {
      document.querySelector('.cart-alert__remaining-message').classList.add('hidden');
      document.querySelector('.cart-alert__qualify-message').classList.remove('hidden');
      document.querySelector('.cart-alert__progress-bar').setAttribute('value', goalValue);
      document.querySelector('.cart-drawer__estimated-shipping').innerHTML = '$0'
    }
    
    let cartDrawerWishlist = document.querySelectorAll('#CartDrawer .quick-add-wishlist');
    cartDrawerWishlist.forEach(function(item) {
      item.remove();
    });
    
    let cartDrawerBlackFridaySale = document.querySelectorAll('#CartDrawer .global-discount__savings');
    if(cartDrawerBlackFridaySale) {
      cartDrawerBlackFridaySale.forEach(function(item) {
        item.remove();
      });
    }

    let cartTotalValue = Number(document.querySelector('.totals__subtotal-value').getAttribute('value'));
    if(gwpProduct.gwpToggle) {
      if(gwpProduct.gwpVariation === 'Auto Add' && gwpProduct.gwpProductInformation.available && cartTotalValue >= gwpProduct.gwpGoal) {
        addAutoAddGiftWithPurchase();
      } else if(gwpProduct.gwpVariation === 'Auto Add' && gwpProduct.gwpProductInformation.available && cartTotalValue < gwpProduct.gwpGoal) {
        removeAutoAddGiftWithPurchase();
      } else if(gwpProduct.gwpVariation === 'User Add' && cartTotalValue >= gwpProduct.gwpGoal && cartTotalValue !== 0) {
        checkIfUserAddGiftProductExistsInCart();
        document.getElementById('userAddGiftWithPurchase').addEventListener('submit', addUserAddGiftWithPurchase);
      } else if(gwpProduct.gwpVariation === 'User Add' && (cartTotalValue < gwpProduct.gwpGoal || cartTotalValue == 0)) {
        checkIfUserAddGiftProductExistsInCart();
        removeUserAddGiftWithPurchase();
      }
    }

    fetch('/cart.js')
    .then((response) => response.json())
    .then((responseText) => {
      let cartItems = responseText.items;
      let cartCrossSellProducts = document.querySelectorAll('.cross-sell__products');

      if (cartItems.filter(e => e.product_type === 'rings').length > 0) {
        cartCrossSellProducts.forEach((upsell) => {
          if(upsell.hasAttribute('ringProductType')) {
            upsell.classList.remove('hidden');
          }
        });
      } else if(cartItems.filter(e => e.product_type === 'rings').length <= 0) {
        cartCrossSellProducts.forEach((upsell) => {
          if(upsell.hasAttribute('ringProductType') && (!upsell.hasAttribute('earringProductType') && !upsell.hasAttribute('necklaceProductType'))) {
            upsell.classList.add('hidden');
          }
        });
      }
      if (cartItems.filter(e => e.product_type === 'earrings').length > 0) {
        cartCrossSellProducts.forEach((upsell) => {
          if(upsell.hasAttribute('earringProductType')) {
            upsell.classList.remove('hidden');
          }
        });
      } else if(cartItems.filter(e => e.product_type === 'earrings').length <= 0) {
        cartCrossSellProducts.forEach((upsell) => {
          if(upsell.hasAttribute('earringProductType') && !upsell.hasAttribute('necklaceProductType') && !upsell.hasAttribute('ringProductType')) {
            upsell.classList.add('hidden');
          }
        });
      }
      if(cartItems.filter(e => e.product_type === 'earrings').length <= 0 && cartItems.filter(e => e.product_type === 'necklaces').length <= 0) {
        cartCrossSellProducts.forEach((upsell) => {
          if(upsell.hasAttribute('earringProductType') && upsell.hasAttribute('necklaceProductType') && !upsell.hasAttribute('ringProductType')) {
            upsell.classList.add('hidden');
          }
        });
      }
      if (cartItems.filter(e => e.product_type === 'necklaces').length > 0) {
        cartCrossSellProducts.forEach((upsell) => {
          if(upsell.hasAttribute('necklaceProductType')) {
            upsell.classList.remove('hidden');
          }
        });
      } else if(cartItems.filter(e => e.product_type === 'necklaces').length <= 0) {
        cartCrossSellProducts.forEach((upsell) => {
          if(upsell.hasAttribute('necklaceProductType') && !upsell.hasAttribute('earringProductType') && !upsell.hasAttribute('ringProductType')) {
            upsell.classList.add('hidden');
          }
        });
      }

      if (cartItems.filter(e => e.product_type === 'bracelets').length > 0) {
        cartCrossSellProducts.forEach((upsell) => {
          if(upsell.hasAttribute('necklaceProductType')) {
            upsell.classList.remove('hidden');
          }
        });
      } else if(cartItems.filter(e => e.product_type === 'bracelets').length <= 0) {
        cartCrossSellProducts.forEach((upsell) => {
          if(upsell.hasAttribute('necklaceProductType') && !upsell.hasAttribute('earringProductType') && !upsell.hasAttribute('ringProductType')) {
            upsell.classList.add('hidden');
          }
        });
      } 
      if(cartItems.filter(e => e.product_type === 'bracelets').length > 0 && cartItems.filter(e => e.product_type === 'earrings').length <=0 && cartItems.filter(e => e.product_type === 'rings').length <=0) {
        cartCrossSellProducts.forEach((upsell) => {
          if(upsell.hasAttribute('earringProductType') && upsell.hasAttribute('ringProductType') && !upsell.hasAttribute('necklaceProductType')) {
            upsell.classList.add('hidden');
          }
        });
      }
  
      if(cartItems.filter(e => e.product_type === 'earrings').length <=0 && cartItems.filter(e => e.product_type === 'rings').length <=0 && cartItems.filter(e => e.product_type === 'necklaces').length > 0) {
        cartCrossSellProducts.forEach((upsell) => {
          if(upsell.hasAttribute('earringProductType') && upsell.hasAttribute('ringProductType') && !upsell.hasAttribute('necklaceProductType')) {
            upsell.classList.add('hidden');
          }
        });
      }
    });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

let cartDrawerWishlist = document.querySelectorAll('#CartDrawer .quick-add-wishlist');
cartDrawerWishlist.forEach(function(item) {
  item.remove();
});

let cartDrawerBlackFridaySale = document.querySelectorAll('#CartDrawer .global-discount__savings');
if(cartDrawerBlackFridaySale) {
  cartDrawerBlackFridaySale.forEach(function(item) {
    item.remove();
  });
}

fetch('/cart.js')
.then((response) => response.json())
.then((responseText) => {
  this.updateCartCrossSells(responseText.items);
});

  function updateCartCrossSells(cartItems) {
    let cartCrossSellProducts = document.querySelectorAll('.cross-sell__products');

    if (cartItems.filter(e => e.product_type === 'rings').length > 0) {
      cartCrossSellProducts.forEach((upsell) => {
        if(upsell.hasAttribute('ringProductType')) {
          upsell.classList.remove('hidden');
        }
      });
    } else if(cartItems.filter(e => e.product_type === 'rings').length <= 0) {
      cartCrossSellProducts.forEach((upsell) => {
        if(upsell.hasAttribute('ringProductType') && (!upsell.hasAttribute('earringProductType') && !upsell.hasAttribute('necklaceProductType'))) {
          upsell.classList.add('hidden');
        }
      });
    }
    if (cartItems.filter(e => e.product_type === 'earrings').length > 0) {
      cartCrossSellProducts.forEach((upsell) => {
        if(upsell.hasAttribute('earringProductType')) {
          upsell.classList.remove('hidden');
        }
      });
    } else if(cartItems.filter(e => e.product_type === 'earrings').length <= 0) {
      cartCrossSellProducts.forEach((upsell) => {
        if(upsell.hasAttribute('earringProductType') && !upsell.hasAttribute('necklaceProductType') && !upsell.hasAttribute('ringProductType')) {
          upsell.classList.add('hidden');
        }
      });
    }
    if(cartItems.filter(e => e.product_type === 'earrings').length <= 0 && cartItems.filter(e => e.product_type === 'necklaces').length <= 0) {
      cartCrossSellProducts.forEach((upsell) => {
        if(upsell.hasAttribute('earringProductType') && upsell.hasAttribute('necklaceProductType') && !upsell.hasAttribute('ringProductType')) {
          upsell.classList.add('hidden');
        }
      });
    }
    if (cartItems.filter(e => e.product_type === 'necklaces').length > 0) {
      cartCrossSellProducts.forEach((upsell) => {
        if(upsell.hasAttribute('necklaceProductType')) {
          upsell.classList.remove('hidden');
        }
      });
    } else if(cartItems.filter(e => e.product_type === 'necklaces').length <= 0) {
      cartCrossSellProducts.forEach((upsell) => {
        if(upsell.hasAttribute('necklaceProductType') && !upsell.hasAttribute('earringProductType') && !upsell.hasAttribute('ringProductType')) {
          upsell.classList.add('hidden');
        }
      });
    }

    if (cartItems.filter(e => e.product_type === 'bracelets').length > 0) {
      cartCrossSellProducts.forEach((upsell) => {
        if(upsell.hasAttribute('necklaceProductType')) {
          upsell.classList.remove('hidden');
        }
      });
    } else if(cartItems.filter(e => e.product_type === 'bracelets').length <= 0) {
      cartCrossSellProducts.forEach((upsell) => {
        if(upsell.hasAttribute('necklaceProductType') && !upsell.hasAttribute('earringProductType') && !upsell.hasAttribute('ringProductType')) {
          upsell.classList.add('hidden');
        }
      });
    } 
    if(cartItems.filter(e => e.product_type === 'bracelets').length > 0 && cartItems.filter(e => e.product_type === 'earrings').length <=0 && cartItems.filter(e => e.product_type === 'rings').length <=0) {
      cartCrossSellProducts.forEach((upsell) => {
        if(upsell.hasAttribute('earringProductType') && upsell.hasAttribute('ringProductType') && !upsell.hasAttribute('necklaceProductType')) {
          upsell.classList.add('hidden');
        }
      });
    }


    if(cartItems.filter(e => e.product_type === 'earrings').length <=0 && cartItems.filter(e => e.product_type === 'rings').length <=0 && cartItems.filter(e => e.product_type === 'necklaces').length > 0) {
      cartCrossSellProducts.forEach((upsell) => {
        if(upsell.hasAttribute('earringProductType') && upsell.hasAttribute('ringProductType') && !upsell.hasAttribute('necklaceProductType')) {
          upsell.classList.add('hidden');
        }
      });
    }
  }

customElements.define('cart-drawer-items', CartDrawerItems);
